import {BaseModel} from '../../_base/crud';

export class ToeStandardModel extends BaseModel {
    id: number;
    terms_of_engagement_id: number;
    valuation_standard_id: number;
    name: string;

    created_at: Date;
    updated_at: Date;

    clear() {
        this.id = undefined;
        this.terms_of_engagement_id = undefined;
        this.valuation_standard_id = undefined;
        this.name = '';

        this.created_at = new Date();
        this.updated_at = new Date();
    }
}